import { redirect } from "react-router-dom";
import { apiSlice } from './index'
import {
	addPage, PageViewResult, PageForm, PageAddTextForm, PageSaveResponse
} from '../features/page/pageSlice'

const pageApi = apiSlice.injectEndpoints({
	endpoints: (builder) => ({
		page: builder.query<PageViewResult, string>({
			query: (id) => `page/view/${id}`,
				async onQueryStarted(args, { dispatch, queryFulfilled }) {
				console.log('page query started');
				try {
					const { data } = await queryFulfilled
					console.log('Data Received', data);
					if (data.page) {
						dispatch(addPage(data.page))
					}
				} catch (err) {
					console.log("ho no, error in page query");
				}
			},
			keepUnusedDataFor: 0,
		}),
		pageSave: builder.mutation<PageSaveResponse, PageForm>({
			query: (body) => {
				const idParam = body.id ? "/" + body.id : "";
				return {
					url: 'page/edit' + idParam,
					method: 'POST',
					body,
				}
			},
			async onQueryStarted(body, { dispatch, queryFulfilled }) {
				try {
					const { data } = await queryFulfilled
					if (data.page) {
						dispatch(addPage(data.page));
					}
				} catch (err) {
					console.log("Error while editing page", err);
				}
			}
		}),
		pageAddText: builder.mutation<PageSaveResponse, PageAddTextForm>({
			query: (body) => {
				const idParam = body.id ? "/" + body.id : "";
				return {
					url: 'page/add-text' + idParam,
					method: 'POST',
					body,
				}
			},
			async onQueryStarted(body, { dispatch, queryFulfilled }) {
				try {
					const { data } = await queryFulfilled
					if (data.page) {
						dispatch(addPage(data.page));
					}
				} catch (err) {
					console.log("Error while editing page", err);
				}
			}
		}),
	}),
})

export const { usePageQuery, usePageSaveMutation, usePageAddTextMutation } = pageApi
